<template>
    <VJoyDialog ref="dialogRef" size="large" @close="onClose">
        <template #dialog-header>
            {{ $t('customer.freelancer.pof.modal.add.favorite.header', [profile?.fullName]) }}
        </template>

        <template #dialog-subheader>
            {{ $t('customer.freelancer.pof.modal.add.favorite.subtitle') }}
        </template>

        <template #dialog-body>
            <FavoriteModalContent v-if="profile" :profile="profile" />
        </template>
    </VJoyDialog>
</template>

<script setup lang="ts">
    import {ref, useTemplateRef, onMounted, onBeforeUnmount} from 'vue';
    import {VJoyDialog} from '@maltjoy/core-vue';
    import {eventBus} from '~/config/events';
    import FavoriteModalContent from './FavoriteModalContent.vue';
    import type {FreelancerProfile} from '../types';

    const dialogRef = useTemplateRef('dialogRef');
    const profile = ref<FreelancerProfile | null>(null);

    function onClose() {
        profile.value = null;
    }

    async function openDialog(profileToDisplay: FreelancerProfile) {
        profile.value = profileToDisplay;
        await dialogRef.value?.show();
    }

    async function hideDialog() {
        await dialogRef.value?.hide();
    }

    onMounted(() => {
        eventBus.on('profile-card:favorite:add-profile:open-dialog', openDialog);
        eventBus.on('profile-card:favorite:add-profile:close-dialog', hideDialog);
    });

    onBeforeUnmount(() => {
        eventBus.off('profile-card:favorite:add-profile:open-dialog', openDialog);
        eventBus.off('profile-card:favorite:add-profile:close-dialog', hideDialog);
    });
</script>
